// src/components/SessionsDialog.jsx
// My Sessions as a pop-up from the profile menu (3.29.3), like My profile
// and Settings — it left the top menu to keep that strip short. Shows only
// the person's own sign-ins (pages/Sessions ownOnly).
import { useEffect, useRef } from 'react';
import Sessions from '../pages/Sessions';
import Emo from './Emo';

export default function SessionsDialog({ onClose }) {
  const closeRef = useRef(null);
  const returnRef = useRef(null);
  // 3.57.5: once, when the window opens (the parent passes a new onClose on
  // every render; re-running moved the cursor to ✕ on every refresh, e.g. a
  // fax pop-up, and the next Space/Enter closed the window)
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  useEffect(() => {
    returnRef.current = document.activeElement;
    closeRef.current?.focus();
    function onKey(e) { if (e.key === 'Escape') { e.preventDefault(); onCloseRef.current(); } }
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('keydown', onKey); returnRef.current?.focus?.(); };
  }, []);
  return (
    <div style={S.overlay} onMouseDown={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={S.modal} role="dialog" aria-modal="true" aria-labelledby="sessions-title">
        <div style={S.header} className="dlg-head">
          <div>
            <h2 id="sessions-title" style={S.title}><Emo e="🔐" /> My sessions</h2>
            <div style={S.sub}>When you signed in and out of the portal.</div>
          </div>
          <button ref={closeRef} onClick={onClose} style={S.closeBtn} aria-label="Close">✕</button>
        </div>
        <div style={S.body}><Sessions ownOnly inDialog /></div>
      </div>
    </div>
  );
}

const S = {
  overlay: { position: 'fixed', inset: 0, background: 'rgb(var(--c-0f2823-rgb) / 0.45)', zIndex: 1200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 },
  modal: { background: 'var(--c-ffffff)', borderRadius: 14, width: 'min(1100px, 100%)', maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 60px rgb(var(--c-000000-rgb) / 0.25)', animation: 'badgePop 0.2s ease-out' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, padding: '18px 22px', borderBottom: '2px solid var(--c-e0f2f1)', background: 'var(--c-f9fafb)', borderRadius: '14px 14px 0 0' },
  title: { margin: 0, fontSize: 19, fontWeight: 700, color: 'var(--t-00695c)', fontFamily: 'inherit' },
  sub: { fontSize: 13, color: 'var(--t-78909c)', marginTop: 2 },
  closeBtn: { width: 34, height: 34, borderRadius: 8, border: '1.5px solid var(--c-e0e0e0)', background: 'var(--c-ffffff)', cursor: 'pointer', fontSize: 15, color: 'var(--t-546e7a)', fontFamily: 'inherit', flexShrink: 0 },
  body: { overflowY: 'auto', padding: '14px 22px 20px' },
};
